/*** Created by hfrancino on 09/08/2024.*/
angular
    .module('annexaApp')
	.component ('annexaAdminListValues', { 
        templateUrl: './components/admin/annexa-admin-list-values/annexa-admin-list-values.html',
        controller: ['HeaderService', '$rootScope', '$state', 'Language', 'TableFilterFactory', '$filter', 'globalModals', 'CommonAdminModals', 'AnnexaFormlyFactory', '$http', 'AnnexaModalFactory', 'RestService', 'CommonService', 'dialogs', 'SecFactory', 'AdminFactory', 'DialogsFactory', '$scope', function (HeaderService, $rootScope, $state, Language, TableFilterFactory, $filter, globalModals, CommonAdminModals, AnnexaFormlyFactory, $http, AnnexaModalFactory, RestService, CommonService, dialogs, SecFactory, AdminFactory, DialogsFactory, $scope) {
            var vm = this;

            vm.deleteObject = function(object, key){
				DialogsFactory.confirm('global.configuration.numbersConfiguration.deleteObjectMessage', 'global.configuration.numbersConfiguration.deleteObjectMessageConfirm').then(function (data) {
					if(vm.model.model && vm.model.model[key]){
						delete vm.model.model[key];
					}
	           }).catch(function (data) {
		               //Empty
		       });
			}
            
            vm.addObject = function(){
            	var object = [];
				var modal = angular.copy(CommonAdminModals.addEtaulerValues);
            	modal.annexaFormly.model = {};
            	
            	var deleteListValue = function(item, index){
                	DialogsFactory.confirm('global.taxBlock.deleteObjectMessage', 'global.taxBlock.deleteObjectMessageConfirm').then(function (data) {
    					if(object && object.length > index){
    						object.splice(index, 1);
    					}
    	           }).catch(function (data) {
    		               //Empty
    		       });
                }
                var addListValue = function(){
                	var modalAux = angular.copy(CommonAdminModals.addEtaulerListValue);
                	modalAux.annexaFormly.model = {};

    				var saveAddObject = function(modalAux){
    					var self = this;
    					if(modalAux && modalAux.annexaFormly && modalAux.annexaFormly.model && modalAux.annexaFormly.model.modal_body && object){
    						var added = {id:modalAux.annexaFormly.model.modal_body.id, 
    								language1:modalAux.annexaFormly.model.modal_body.language1, 
    								language2:modalAux.annexaFormly.model.modal_body.language2, 
    								language3:modalAux.annexaFormly.model.modal_body.language3, 
                    				defaultValue:((modalAux.annexaFormly.model.modal_body && modalAux.annexaFormly.model.modal_body.defaultValue_true)?modalAux.annexaFormly.model.modal_body.defaultValue_true:false), 
                    				linked:modalAux.annexaFormly.model.modal_body.linked};
    						object.push(added);
    						modalAux.close();
                    	}
    				}
    				AnnexaFormlyFactory.showModal('modalNewListValue', modalAux, saveAddObject, false);
                }
                var editListValue = function(item, index){
                	var modalAux = angular.copy(CommonAdminModals.addEtaulerListValue);
                	modalAux.annexaFormly.model = {
                			modal_body:{
                				id:((item)?item.id:undefined), 
                				language1:((item)?item.language1:undefined), 
                				language2:((item)?item.language2:undefined), 
                				language3:((item)?item.language3:undefined), 
                				defaultValue:((item)?item.defaultValue:false), 
                				defaultValue_true:((item)?item.defaultValue:false),
                				linked:((item)?item.linked:undefined)
                			}
                	};

    				var saveAddObject = function(modalAux){
    					var self = this;
    					if(modalAux && modalAux.annexaFormly && modalAux.annexaFormly.model && modalAux.annexaFormly.model.modal_body && object){
    						if(object.length > index){
    							object[index] = {id:modalAux.annexaFormly.model.modal_body.id, 
    									language1:modalAux.annexaFormly.model.modal_body.language1, 
    									language2:modalAux.annexaFormly.model.modal_body.language2, 
    									language3:modalAux.annexaFormly.model.modal_body.language3, 
    									defaultValue:((modalAux.annexaFormly.model.modal_body.defaultValue_true)?modalAux.annexaFormly.model.modal_body.defaultValue_true:false), 
    									linked:modalAux.annexaFormly.model.modal_body.linked};
    						}
    						modalAux.close();
                    	}
    				}
    				AnnexaFormlyFactory.showModal('modalEditListValue', modalAux, saveAddObject, false);
                }
				
				var listValuesField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'listValues'");
                if(listValuesField) {
                	listValuesField.data.list = object;
                	listValuesField.data.deleteObject = deleteListValue;
                	listValuesField.data.addObject = addListValue;
                	listValuesField.data.editObject = editListValue;
                }

            	var saveAddObject = function(modal) {
            	    if (modal && modal.annexaFormly && modal.annexaFormly.model && modal.annexaFormly.model.modal_body
            	    		&& modal.annexaFormly.model.modal_body.name && modal.annexaFormly.model.modal_body.name != '') {
            	    	vm.model.model[modal.annexaFormly.model.modal_body.name] = [];
            	    	var listValuesField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'listValues'");
            	    	if(listValuesField && listValuesField.data && listValuesField.data.list && listValuesField.data.list.length > 0) {
            	    		vm.model.model[modal.annexaFormly.model.modal_body.name] = listValuesField.data.list;
            	    	}
            	        modal.close();
            	    }
            	}
				AnnexaFormlyFactory.showModal('modalNewEtaulerValues', modal, saveAddObject, false);
			}
            
            vm.editObject = function(object, $index, key){
				var modal = angular.copy(CommonAdminModals.addEtaulerValues);
            	modal.annexaFormly.model = {modal_body:{name:key, origName:key}};
            	var deleteListValue = function(item, index){
                	DialogsFactory.confirm('global.taxBlock.deleteObjectMessage', 'global.taxBlock.deleteObjectMessageConfirm').then(function (data) {
    					if(object && object.length > index){
    						object.splice(index, 1);
    					}
    	           }).catch(function (data) {
    		               //Empty
    		       });
                }
                var addListValue = function(){
                	var modalAux = angular.copy(CommonAdminModals.addEtaulerListValue);
                	modalAux.annexaFormly.model = {};

    				var saveAddObject = function(modalAux){
    					var self = this;
    					if(modalAux && modalAux.annexaFormly && modalAux.annexaFormly.model && modalAux.annexaFormly.model.modal_body && object){
    						var added = {id:modalAux.annexaFormly.model.modal_body.id, 
    								language1:modalAux.annexaFormly.model.modal_body.language1, 
    								language2:modalAux.annexaFormly.model.modal_body.language2, 
    								language3:modalAux.annexaFormly.model.modal_body.language3, 
                    				defaultValue:((modalAux.annexaFormly.model.modal_body.defaultValue_true)?modalAux.annexaFormly.model.modal_body.defaultValue_true:false), 
                    				linked:modalAux.annexaFormly.model.modal_body.linked};
    						object.push(added);
    						modalAux.close();
                    	}
    				}
    				AnnexaFormlyFactory.showModal('modalNewListValue', modalAux, saveAddObject, false);
                }
                var editListValue = function(item, index){
                	var modalAux = angular.copy(CommonAdminModals.addEtaulerListValue);
                	modalAux.annexaFormly.model = {
                			modal_body:{
                				id:((item)?item.id:undefined), 
                				language1:((item)?item.language1:undefined), 
                				language2:((item)?item.language2:undefined), 
                				language3:((item)?item.language3:undefined), 
                				defaultValue:((item)?item.defaultValue:undefined), 
                				defaultValue_true:((item)?item.defaultValue:false),
                				linked:((item)?item.linked:undefined)
                			}
                	};

    				var saveAddObject = function(modalAux){
    					var self = this;
    					if(modalAux && modalAux.annexaFormly && modalAux.annexaFormly.model && modalAux.annexaFormly.model.modal_body && object){
    						if(object.length > index){
    							object[index] = {id:modalAux.annexaFormly.model.modal_body.id, 
    									language1:modalAux.annexaFormly.model.modal_body.language1, 
    									language2:modalAux.annexaFormly.model.modal_body.language2, 
    									language3:modalAux.annexaFormly.model.modal_body.language3, 
    									defaultValue:((modalAux.annexaFormly.model.modal_body.defaultValue_true)?modalAux.annexaFormly.model.modal_body.defaultValue_true:false), 
    									linked:modalAux.annexaFormly.model.modal_body.linked};
    						}
    						modalAux.close();
                    	}
    				}
    				AnnexaFormlyFactory.showModal('modalEditListValue', modalAux, saveAddObject, false);
                }
				
				var listValuesField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'listValues'");
                if(listValuesField) {
                	listValuesField.data.list = object;
                	listValuesField.data.deleteObject = deleteListValue;
                	listValuesField.data.addObject = addListValue;
                	listValuesField.data.editObject = editListValue;
                }
				
				var saveAddObject = function(modal){
            	    if (modal && modal.annexaFormly && modal.annexaFormly.model && modal.annexaFormly.model.modal_body
            	    		&& modal.annexaFormly.model.modal_body.name && modal.annexaFormly.model.modal_body.name != '') {
            	    	
            	    	if(!vm.model.model[modal.annexaFormly.model.modal_body.name]){
            	    		var newModel = {};
            	    		_.forEach(Object.entries(vm.model.model), function (value, key) {
            	    			if(value[0] === modal.annexaFormly.model.modal_body.origName){
            	    				newModel[modal.annexaFormly.model.modal_body.name] = value[1];
            	    			} else {
            	    				newModel[value[0]] = value[1];
            	    			}
                        	});
            	    		vm.model.model = newModel;
    					}
            	    	
            	    	var listValuesField = $linq(modal.annexaFormly.fields[0].fieldGroup).firstOrDefault(undefined, "x => x.key == 'listValues'");
            	    	if(listValuesField && listValuesField.data && listValuesField.data.list && listValuesField.data.list.length > 0) {
            	    		vm.model.model[modal.annexaFormly.model.modal_body.name] = listValuesField.data.list;
            	    	}
            	        modal.close();
            	    }
				}
				AnnexaFormlyFactory.showModal('modalEditEtaulerValues', modal, saveAddObject, false);
			}
            
            vm.getParamValuesString = function(param) {
            	if (!Array.isArray(param)) return '';

                var column = Language.getActiveColumn();
                var names = [];
                
                _.forEach(param, function(item, index) {
                    if (index < 3 && item && item[column] !== undefined) {
                        names.push(item[column]);
                    }
                });

                var result = names.join(', ');
                return param.length > 3 ? result + ', ...' : result;
            }
            
        }],
        bindings: {
            model: '='
        }
    });